/*============================================================================
  Offer Information Drawer
==============================================================================*/
(function() {
  'use strict';

  var OfferInformationDrawer = (function() {
    var selectors = {
      drawer: '#OfferInformationDrawer',
      drawerOpen: '[data-offer-info-drawer-open]',
      drawerClose: '[data-offer-info-drawer-close]',
      drawerOverlay: '[data-offer-info-drawer-overlay]',
      drawerContent: '[data-offer-info-drawer-content]'
    };

    var drawerInstance = null;

    function OfferInformationDrawer() {
      this.init();
    }

    OfferInformationDrawer.prototype.init = function() {
      var self = this;
      var $drawer = $(selectors.drawer);
      var $overlay = $(selectors.drawerOverlay);
      
      if (!$drawer.length) {
        return;
      }

      // Open drawer when button is clicked
      $(document).on('click', selectors.drawerOpen, function(e) {
        e.preventDefault();
        e.stopPropagation();
        var vendor = ($(this).attr('data-offer-vendor') || 'makita').toLowerCase();
        self.setActivePanel(vendor);
        self.open();
      });

      // Close drawer when close button is clicked - use multiple selectors for reliability
      $(document).on('click.offerInfoDrawer', selectors.drawerClose + ', .ctm-info-drawer-close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        self.close();
        return false;
      });
      
      // Additional direct binding on drawer element for extra reliability
      $(selectors.drawer).on('click.offerInfoDrawer', selectors.drawerClose + ', .ctm-info-drawer-close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        self.close();
        return false;
      });

      // Close drawer when overlay is clicked
      $(document).on('click.offerInfoDrawer', selectors.drawerOverlay, function(e) {
        e.preventDefault();
        e.stopPropagation();
        self.close();
        return false;
      });

      // Close on ESC key
      $(document).on('keyup.offerInfoDrawer', function(e) {
        if (e.keyCode === 27 && $drawer.hasClass('ctm-info-drawer-open')) {
          self.close();
        }
      });

      // Prevent drawer content area clicks from bubbling, but allow header/close button clicks
      $drawer.find('.offer-information-drawer__content').on('click', function(e) {
        e.stopPropagation();
      });
    };

    OfferInformationDrawer.prototype.setActivePanel = function(vendor) {
      var $drawer = $(selectors.drawer);
      var $panels = $drawer.find('[data-offer-info-panel]');
      if (!$panels.length) return;

      var matched = false;
      $panels.each(function() {
        var panelVendor = ($(this).attr('data-offer-info-panel') || '').toLowerCase();
        if (panelVendor === vendor) {
          $(this).prop('hidden', false).show();
          matched = true;
        } else {
          $(this).prop('hidden', true).hide();
        }
      });

      if (!matched) {
        $panels.first().prop('hidden', false).show();
      }
    };

    OfferInformationDrawer.prototype.open = function() {
      var $drawer = $(selectors.drawer);
      var $overlay = $(selectors.drawerOverlay);
      var $body = $('body');
      
      $body.addClass('ctm-info-drawer-open');
      $drawer.addClass('ctm-info-drawer-open');
      $overlay.addClass('ctm-info-overlay-visible');
      
      // Prevent body scroll
      $body.css('overflow', 'hidden');
    };

    OfferInformationDrawer.prototype.close = function() {
      var $drawer = $(selectors.drawer);
      var $overlay = $(selectors.drawerOverlay);
      var $body = $('body');
      
      $body.removeClass('ctm-info-drawer-open');
      $drawer.removeClass('ctm-info-drawer-open');
      $overlay.removeClass('ctm-info-overlay-visible');
      
      // Restore body scroll
      $body.css('overflow', '');
    };

    return OfferInformationDrawer;
  })();

  // Initialize on DOM ready
  $(document).ready(function() {
    if ($('#OfferInformationDrawer').length) {
      new OfferInformationDrawer();
    }
  });

  // Also support window load for edge cases
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if ($('#OfferInformationDrawer').length) {
        new OfferInformationDrawer();
      }
    });
  } else {
    if ($('#OfferInformationDrawer').length) {
      new OfferInformationDrawer();
    }
  }

})();

